import AppSource from '../../data/app-source';
import UrlParser from '../../routes/url-parser';
import AyahToolInitiator from '../../utils/ayah-tool/ayah-tool-initiator';
import NavSurahToolInitiator from '../../utils/nav-surah-tool/nav-surah-tool-initiator';
import {
  createAyahTemplate,
  createContentFailedTemplate,
  createLoadingTemplate,
  createSurahSummaryTemplate,
} from '../templates/template-creator';

class Surah extends HTMLElement {
  connectedCallback() {
    const page = UrlParser.parseActiveUrlWithoutCombiner().id;
    this.render(page);
    this._insertData(page);
    this._handlerNavSurahTool(page);
  }

  render(page) {
    this.innerHTML = `
      <section id="jump-page-container" class="hidden fixed top-[20%] right-0 left-0 z-10 w-11/12 lg:w-3/5 mx-auto p-3 bg-white backdrop-blur-lg bg-opacity-40 border border-[#35A29F] rounded-lg">
        <form id="form-input-surah" class="flex flex-col">
          <label for="input-num-surah" class="text-center md:text-lg mb-3" tabindex="0">Masukkan nomor surah antara 1 - 114</label>
          <input type="number" min="1" max="114" placeholder="1 - 114" id="input-num-surah" class="form-input text-center text-black md:text-lg w-1/3 mx-auto" required/>
          <button type="submit" id="form-btn-submit-input-surah" disabled class="bg-[#aaa] text-white rounded my-3 md:mx-auto md:w-3/4">Pergi ke surah</button>
          <button type="reset" id="form-btn-close-input-surah" class="text-[#0B666A] border-t border-[#0B666A] mt-2">Tutup</button>
        </form>
      </section>
      <section class="flex justify-between items-center my-2">
        <button id="btn-next-surah" class="animate-pulse w-16 md:w-20" title="Surah Selanjutnya">
          <img src="./icons/left-arrow-icon.svg" alt="left arrow icon">
        </button>
        <div class="text-line-h w-full md:before:ms-20 md:after:me-20">
          <button id="btn-jump-page" class="text-center md:text-lg text-[#35A29F] border-x border-[#35A29F] rounded-lg">
            Surah Ke - &nbsp;<span>${page}<span>
          </button>
        </div>
        <button id="btn-prev-surah" class="animate-pulse w-16 md:w-20" title="Surah Sebelumnya">
          <img src="./icons/right-arrow-icon.svg" alt="right arrow icon">
        </button>
      </section>
      <article id="container-surah" class="w-11/12 lg:w-3/5 mb-20 md:mb-24 m-auto">
        <section id="container-summary"></section>
        <section id="container-ayah"></section>
      </article>
    `;
  }

  _handlerNavSurahTool(page) {
    const btnNextSurah = this.querySelector('#btn-next-surah');
    const btnPrevSurah = this.querySelector('#btn-prev-surah');
    const btnJumpPage = this.querySelector('#btn-jump-page');
    const jumpPageContainer = this.querySelector('#jump-page-container');
    const formInputSurah = this.querySelector('#form-input-surah');
    const inputNumSurah = this.querySelector('#input-num-surah');
    const formBtnSubmitInputSurah = this.querySelector('#form-btn-submit-input-surah');
    const formBtnCloseInputSurah = this.querySelector('#form-btn-close-input-surah');
    NavSurahToolInitiator.init({
      page,
      btnNextSurah,
      btnPrevSurah,
      btnJumpPage,
      jumpPageContainer,
      formInputSurah,
      inputNumSurah,
      formBtnSubmitInputSurah,
      formBtnCloseInputSurah,
    });
  }

  async _insertData(page) {
    this.innerHTML += createLoadingTemplate();
    const containerSurah = this.querySelector('#container-surah');
    const surah = await AppSource.getSurah(page);
    if (!surah.error) {
      this._insertDataSummary(surah, page);
      this._insertDataAyah(surah, page);
    } else {
      containerSurah.innerHTML = createContentFailedTemplate();
    }
    this.lastElementChild.remove();
  }

  // ============================ Data Summary ============================

  _insertDataSummary(surah, numSurah) {
    const containerSummary = this.querySelector('#container-summary');
    containerSummary.innerHTML += createSurahSummaryTemplate(surah.data);
    this._handlerSummaryOnClick(surah);
    this._removeBismillah(numSurah);
    this._handlerJumpAyah(surah);
  }

  _handlerSummaryOnClick(surah) {
    const descSurah = this.querySelector('#desc-surah');
    const btnDescSurah = this.querySelector('#btn-desc-surah');
    btnDescSurah.addEventListener('click', () => {
      descSurah.classList.toggle('open');
      if (descSurah.classList.contains('open')) {
        descSurah.innerHTML = surah.data.description;
        btnDescSurah.innerHTML = 'Sembunyikan';
      } else {
        descSurah.innerHTML = surah.data.description.slice(0, 140);
        btnDescSurah.innerHTML = 'Selengkapnya...';
      }
    });
  }

  _removeBismillah(numSurah) {
    const bismillahContainer = this.querySelector('#bismillah-container');
    if (numSurah === '1' || numSurah === '9') bismillahContainer.remove();
  }

  _handlerJumpAyah(surah) {
    const formSearchAyah = this.querySelector('#form-search-ayah');
    const inputNumAyah = this.querySelector('#input-num-ayah');
    const {
      ayahs, number, name, translation, revelation,
    } = surah.data;
    const totalItem = ayahs.length;
    formSearchAyah.addEventListener('submit', (event) => {
      event.preventDefault();
      const baseItem = Number(inputNumAyah.value);
      this._handlerSearchAyah({
        surah,
        ayahs,
        number,
        name,
        translation,
        revelation,
        totalItem,
        baseItem,
      });
    });
  }

  _handlerSearchAyah({
    surah,
    ayahs,
    number,
    name,
    translation,
    revelation,
    totalItem,
    baseItem,
  }) {
    const containerAyah = this.querySelector('#container-ayah');
    const currentItem = containerAyah.children.length;
    const isNotExistItem = currentItem < baseItem;
    if (isNotExistItem) {
      this._updateDataAyah({
        surah,
        ayahs,
        number,
        name,
        translation,
        revelation,
        containerAyah,
        totalItem,
        currentItem,
        baseItem,
      });
    }
    const ayahPosition = this.querySelector(`#ayah-${baseItem}`).offsetTop;
    window.scrollTo({
      top: ayahPosition - 150,
      behavior: 'smooth',
    });
  }

  // ============================ Data Ayah ============================

  _insertDataAyah(surah, page) {
    const containerAyah = this.querySelector('#container-ayah');
    const {
      ayahs, number, name, translation, revelation,
    } = surah.data;
    const totalItem = ayahs.length;
    const baseItem = 10;
    const countItem = totalItem > baseItem ? baseItem : totalItem;
    for (let index = 0; index < countItem; index++) {
      ayahs[index].ayahNumber = ayahs[index].number.inSurah;
      ayahs[index].surahNumber = number;
      ayahs[index].surahName = name;
      ayahs[index].surahTranslation = translation;
      ayahs[index].surahRevelation = revelation;
      containerAyah.innerHTML += createAyahTemplate(ayahs[index]);
    }
    this._handlerAyahTool(surah);
    this._handlerOnScroll({
      surah, ayahs, number, name, translation, revelation, containerAyah, totalItem, baseItem,
    });
    this._checkBookmark({
      page, surah, ayahs, number, name, translation, revelation, totalItem,
    });
    this._handlerGoToBookmark({
      page, surah, ayahs, number, name, translation, revelation, totalItem,
    });
  }

  _handlerAyahTool(surah) {
    const btnTafsirAyah = this.querySelectorAll('#btn-tafsir-ayah');
    const btnPlayAyah = this.querySelectorAll('#btn-play-ayah');
    const btnBookmarkAyah = this.querySelectorAll('#btn-bookmark-ayah');
    const btnFavoriteAyah = this.querySelectorAll('#btn-favorite-ayah');
    const btnCopyAyah = this.querySelectorAll('#btn-copy-ayah');
    AyahToolInitiator.init({
      surah, btnTafsirAyah, btnPlayAyah, btnBookmarkAyah, btnFavoriteAyah, btnCopyAyah,
    });
  }

  _handlerOnScroll({
    surah, ayahs, number, name, translation, revelation, containerAyah, totalItem, baseItem,
  }) {
    window.onscroll = () => {
      const windowHeight = window.innerHeight + window.pageYOffset + 150;
      const bodyHeight = document.body.offsetHeight;
      const isEndPage = windowHeight >= bodyHeight;
      const currentItem = containerAyah.children.length;
      if (isEndPage) {
        const isAddItem = currentItem < totalItem;
        if (isAddItem) {
          this._updateDataAyah({
            surah,
            ayahs,
            number,
            name,
            translation,
            revelation,
            containerAyah,
            totalItem,
            currentItem,
            baseItem,
          });
        }
      }
    };
  }

  _updateDataAyah({
    surah,
    ayahs,
    number,
    name,
    translation,
    revelation,
    containerAyah,
    totalItem,
    currentItem,
    baseItem,
  }) {
    const remainItem = totalItem - currentItem;
    const countAddItem = remainItem > baseItem ? baseItem : remainItem;
    for (let index = currentItem; index < currentItem + countAddItem; index++) {
      ayahs[index].ayahNumber = ayahs[index].number.inSurah;
      ayahs[index].surahNumber = number;
      ayahs[index].surahName = name;
      ayahs[index].surahTranslation = translation;
      ayahs[index].surahRevelation = revelation;
      containerAyah.innerHTML += createAyahTemplate(ayahs[index]);
    }
    this._handlerAyahTool(surah);
  }

  // ============================ Bookmark ============================

  _checkBookmark({
    page, surah, ayahs, number, name, translation, revelation, totalItem,
  }) {
    const bookmark = JSON.parse(localStorage.getItem('BOOKMARK'));
    if (bookmark && page === bookmark.surahNumber) {
      const baseItem = Number(bookmark.ayahNumber);
      this._handlerSearchAyah({
        surah,
        ayahs,
        number,
        name,
        translation,
        revelation,
        totalItem,
        baseItem,
      });
    }
  }

  _handlerGoToBookmark({
    page, surah, ayahs, number, name, translation, revelation, totalItem,
  }) {
    const btnToBookmark = this.querySelector('#btn-to-bookmark');
    btnToBookmark.addEventListener('click', () => {
      const bookmark = JSON.parse(localStorage.getItem('BOOKMARK'));
      if (bookmark && page === bookmark.surahNumber) {
        const baseItem = Number(bookmark.ayahNumber);
        this._handlerSearchAyah({
          surah,
          ayahs,
          number,
          name,
          translation,
          revelation,
          totalItem,
          baseItem,
        });
      } else if (bookmark && page !== bookmark.surahNumber) {
        location.assign(`#/surah/${bookmark.surahNumber}`);
      } else alert('Belum ada ayat yang ditandai sebagai Terakhir Dibaca.');
    });
  }
}

customElements.define('surah-page', Surah);
const surah = '<surah-page></surah-page>';
export default surah;
